let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fogZm")).then(() => parcelRequire('1ZfHS'));